import _get from 'lodash/get';
const TYPE_CONST = {
  // Add more clickType conversion if needed
  clickTypeObject: {
    alpha: 'alp',
    'alpha-dealer': 'alp-dlr',
    alpham: 'alpm',
    'alpham-dealer': 'alpm-dlr',
    spotlight: 'spv',
    listing: 'lstg',
    compare: 'comp',
    elot: 'elot',
    recommendations: 'recommendations'
  },
  parObject: {
    alp_c: 'alp',
    ddv_lstg: 'ddp',
    spv_lstg: 'spv',
    sup_v_lstg: 'sup',
    v_lstg: 'lstg',
    dl_v_lstg: 'elot',
    markt_lnd: 'elot',
    ncb: 'ncb',
    ime: 'ime'
  },
  pageIdObject: {
    fyd_srl: 'fyd_srl',
    fyd_ddp: 'ddp',
    markt_lnd: 'elot'
  }
};
export const convertClickTypeToListingType = clickType => _get(TYPE_CONST, ['clickTypeObject', clickType], clickType || '');

// remove _index at end of string
export function convertParValue(par) {
  return par.replace(/_\d+$/, '');
}
export function getListingType(pageId, par) {
  if (par) {
    return _get(TYPE_CONST, ['parObject', convertParValue(par)]) || par;
  }
  if (!par && pageId) {
    return _get(TYPE_CONST, ['pageIdObject', pageId]) || pageId;
  }
  return null;
}
export default {
  convertClickTypeToListingType,
  getListingType
};